export const CONVERGENCE_STRATEGY_VALUES = ["hard_cut", "ellipse", "establishing_shot", "neutral_insert", "new_angle"];
export const ConvergenceStrategy = {
    HARD_CUT: "hard_cut",
    ELLIPSE: "ellipse",
    ESTABLISHING_SHOT: "establishing_shot",
    NEUTRAL_INSERT: "neutral_insert",
    NEW_ANGLE: "new_angle",
};
export const CONVERGENCE_STRATEGY_LABELS = {
    [ConvergenceStrategy.HARD_CUT]: "Cut franc",
    [ConvergenceStrategy.ELLIPSE]: "Ellipse",
    [ConvergenceStrategy.ESTABLISHING_SHOT]: "Plan d'ensemble",
    [ConvergenceStrategy.NEUTRAL_INSERT]: "Insert neutre",
    [ConvergenceStrategy.NEW_ANGLE]: "Nouvel angle",
};
